module.exports = __webpack_public_path__ + "static/media/landing_rate.1a551025.png";